// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconCurrencyRupee } from '@tabler/icons';

const icons = {
    IconCurrencyRupee
};

// ==============================|| MENU ITEMS - PAYROLL ||============================== //

const payroll = {
    id: 'payroll',
    title: <FormattedMessage id="payroll" />,
    icon: icons.IconCurrencyRupee,
    type: 'group',
    url: 'payroll',
    roles: ['employee', 'employer']
};

export default payroll;
